import { HomePage } from "core/pages";

export default HomePage;
